import { z } from "zod";

import { baseApiResponse } from "./BaseApiResponse";

export const countryResolver = z.object({
	iso2: z.string(),
	iso3: z.string(),
	phoneCode: z.string().nullable(),
	title: z.string(),
	value: z.string()
});

export type CountryModel = z.infer<typeof countryResolver>;

export const getCountriesResult = baseApiResponse.omit({ data: true }).extend({
	data: z.object({
		countries: countryResolver.array()
	})
});

export type GetCountriesResult = z.infer<typeof getCountriesResult>;
